export default {
    modelValue: {
        type: Array,
        default: undefined
    },
    largeStep: {
        type: Number,
        default: undefined
    },
    leftDragHandleTitle: {
        type: String,
        default: undefined
    },
    max: {
        type: Number,
        default: undefined
    },
    min: {
        type: Number,
        default: undefined
    },
    orientation: {
        type: String,
        default: undefined
    },
    rightDragHandleTitle: {
        type: String,
        default: undefined
    },
    selectionEnd: {
        type: Number,
        default: undefined
    },
    selectionStart: {
        type: Number,
        default: undefined
    },
    smallStep: {
        type: Number,
        default: undefined
    },
    tickPlacement: {
        type: String,
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    value: {
        type: Array,
        default: undefined
    },

    // Events
    change: Function,
    slide: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/RangeSliderProps.js